<template>
  <div class="payment-bubble">
    <BubbleHeader>{{message.message_description}}</BubbleHeader>
    <template v-if="$hasPermission('can_view_payments')">
      <BubbleTextRow v-if="text"><BubbleTextMsg :text="text" /></BubbleTextRow>

      <MsgblContent :type="message.direction" v-if="message.showEntityLink">
        <MsgblLinkHeader icon="payments" 
                        :title="message.appointment_title"
                        @click="navigateTo" />
      </MsgblContent>

      <MsgblContent :type="message.direction" v-if="message.showEntityCard">
        <MsgblLinkHeader icon="payments" 
                        :title="message.appointment_title"
                        @click="navigateTo" />

        <MsgblTextRow>
          <MsgblTextLabel>{{$t(payment.state_summary.state_h)}}:</MsgblTextLabel>
          <MsgblTextValue>{{payment.amount_h}}</MsgblTextValue>
        </MsgblTextRow>

        <MsgblActions :actions="actions" 
                      @action="actionClicked" />
      </MsgblContent>
    </template>

    <MsgblNoAccess v-else
                   icon="payments"
                   :direction="message.direction">
    </MsgblNoAccess>

  </div>
</template>

<script>
import {
  BubbleHeader,
  BubbleTextRow,
  BubbleTextMsg,
  MsgblContent,
  MsgblLinkHeader,
  MsgblTextRow,
  MsgblNoAccess,
  MsgblTextLabel,
  MsgblTextValue,
  MsgblActions
} from './helpers'

export default {
  name: 'PaymentBubble',
  components: {
    BubbleHeader,
    BubbleTextRow,
    BubbleTextMsg,
    MsgblContent,
    MsgblLinkHeader,
    MsgblTextRow,
    MsgblNoAccess,
    MsgblTextLabel,
    MsgblTextValue,
    MsgblActions,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  computed: {
    payment() {
      return this.message.messageable
    },
    actions() {
      return this.payment.state_summary.actions.map( action => {
        if (action.name === 'mark_as_paid' && this.payment.paid_at) {
          action.name_h = this.$t('payment.action.uncancel')
        }
        return action
      })

    },
    clientMessage() {
      return this.message.direction === 'client_to_business'
    },
    text() {
      return (this.clientMessage && this.payment.notes) ? this.payment.notes : null
    }
  },
  methods: {
    actionClicked({action}) {
      const data = {
        payment: this.payment
      }
      
      if (action === 'view') {
        data.link = `/payments/${this.payment.uid}/view`
      }

      this.$frontageApi.send('payment-bubble-action', {action, data})
    },
    navigateTo() {
      this.$frontageApi.navigateTo('app.payment.show', {uid: this.payment.uid})
    }
  },
}
</script>